export function average(numbers: number[]): number {
  const numOfNums = numbers.length;
  const reducer = (accumulator: number, currentValue: number) =>
    accumulator + currentValue;
  const total = numbers.reduce(reducer);
  return total / numOfNums;
}
